export const ACTIVE_FILTER_OPTIONS = [
  { value: "hideInactive", label: "Hide Inactive" },
  { value: "inactiveOnly", label: "Show Inactive Only" },
  { value: "all", label: "Show All" },
];

export const isProductInactive = (product) => {
  if (product?.isActive === false) return true;
  const sections = product?.sectionWiseProductDetailList || [];
  return sections.length > 0 && sections.every((s) => !s.isActive);
};

export const filterByActiveStatus = (products, mode) => {
  if (mode === "all") return products;
  if (mode === "inactiveOnly") return (products || []).filter(isProductInactive);
  return (products || []).filter((p) => !isProductInactive(p));
};
